module.exports = __webpack_public_path__ + "static/media/Jano.9799120b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/testimonials/Jano.png
// module id = 1427
// module chunks = 0